export function isAgent(nick) {
  return nick.startsWith('agent:');
}

export function isTrigger(nick) {
  return nick.startsWith('agent:trigger');
}

export * from './PersistentStorage';

export function log(msg) {
  console.log(msg);
}
